import {Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {SubscriptionService} from "@app/shared/data-cart2";
import {ProductService} from "@app/shared/data-products";
import {combineLatest, filter, mergeMap} from "rxjs";
import {IProduct} from "@app/data-interfaces";
import {filterNilValue} from "@datorama/akita";
import {filterNil} from "@ngneat/elf";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
@UntilDestroy()
@Component({
  selector: 'app-subscription-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './subscription-list.component.html',
  styleUrls: ['./subscription-list.component.scss']
})
export class SubscriptionListComponent implements OnInit{
  subs$;

  constructor(private subService: SubscriptionService, private productService: ProductService) {
    this.subs$ = subService.selectSubscriptions();

  }

  ngOnInit() {
    this.subService.loadMySubscriptions().subscribe();
    this.subs$.pipe(mergeMap(subs => {
      return this.productService.loadByIds(subs.map(sub => sub.product_id));
    }), untilDestroyed(this)).subscribe();
  }

  getProduct(id:number) {
    return this.productService.selectById(id).pipe(filterNil());
  }
}

